import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {Vessel} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
    selector: 'app-edit-vessel',
    templateUrl: './edit-vessel.component.html',
    styleUrls: ['./edit-vessel.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditVesselComponent {
  @Input() vessel: Vessel;
}
